<template>
  <div slot-scope="{ form, methods }" class="space-y-6">

    <vehicles-card :form="form" :methods="methods" />
    
    <div class="card">
      <div class="card-header">
        Conditions
      </div>
      <div class="p-6">
        <div class="text-gray-500">
          Select the areas to watch for when one of the selected vehicles enters and/or leaves.
        </div>
        <radio-group
          class="mt-6"
          v-model="form.condition"
          :options="[
            { value: 0, label: 'Leaves' },
            { value: 1, label: 'Enters' },
            { value: 2, label: 'Enters & Leaves' }
          ]" />

        <AreaToggle 
          class="mt-6" 
          :parent="form" 
          @toggle="methods.toggleArea" />
      </div>
    </div>

    <schedule-card :form="form" :methods="methods" />

    <contacts-card :form="form" :methods="methods" />

    <driver-device-card :form="form" :methods="methods" />
    
    <monitor-card :form="form" :methods="methods" />
    
  </div>
</template>

<script>
  import AreaToggle from '@/components/AreaToggle'
  import ContactsCard from '@/views/automations/components/ContactsCard'
  import DriverDeviceCard from '@/views/automations/components/DriverDeviceCard'
  import MonitorCard from '@/views/automations/components/MonitorCard'
  import ScheduleCard from '@/views/automations/components/ScheduleCard'
  import VehiclesCard from '@/views/automations/components/VehiclesCard'
  
  export default {
    name: 'MultiAreaChange',
    
    components: { 
      AreaToggle,
      ContactsCard,
      DriverDeviceCard,
      MonitorCard,
      ScheduleCard,
      VehiclesCard
    },

    props: ['form', 'methods']
  }
</script>